import { Box, Card, Spinner } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ChartSkeleton } from 'modules/performance_analytics/components/ChartSkeleton'

import { HeadcountChart } from './components/HeadcountChart'
import { LoadingState } from './components/LoadingState'
import { useHeadcountData } from './hooks/useHeadcountData'
import { HeadcountProps } from './lib/types'

export const Headcount = ({ groupBy, employeeTotalCount }: HeadcountProps) => {
  const headcountData = useHeadcountData({
    groupBy,
  })

  if (!headcountData) {
    return <LoadingState />
  }

  const {
    chartData,
    hasRecords,
    dataTableFilters,
    enabledFilters,
    availableFilters,
    onAddFilter,
    onUpdateFilter,
    legalEntities,
    teams,
    locations,
    employees,
    loading,
  } = headcountData
  const isEmpty = employeeTotalCount == 0

  if (loading) {
    return (
      <Box height="s400" width="full">
        <Card>
          <Card.Content>
            <Box alignSelf="center" flexDirection="column">
              <Box paddingTop="s140">
                <Spinner />
              </Box>
            </Box>
          </Card.Content>
        </Card>
      </Box>
    )
  }

  return (
    <Box height="s400" width="full">
      <Card>
        <Card.Title size="small" tooltip={'performance_process.analytics.headcount.tooltip'}>
          {i18n.t('performance_process.analytics.headcount.title')}
        </Card.Title>
        <Card.Description>
          {employeeTotalCount
            ? i18n.t('performance_process.analytics.headcount.description', {
                employees_count: employeeTotalCount,
              })
            : ''}
        </Card.Description>
        <Card.Content>
          {isEmpty || !hasRecords ? (
            <ChartSkeleton hasRecords={hasRecords} />
          ) : (
            <HeadcountChart
              data={chartData}
              dataTableFilters={dataTableFilters}
              enabledFilters={enabledFilters}
              availableFilters={availableFilters}
              onAddFilter={onAddFilter}
              onUpdateFilter={onUpdateFilter}
              groupBy={groupBy}
              teams={teams}
              locations={locations}
              employeesNames={employees}
              legalEntities={legalEntities}
            />
          )}
        </Card.Content>
      </Card>
    </Box>
  )
}
